import React, { Component } from 'react';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import services from '../../../services';
import $ from "jquery";
import NumericCellDinamic from './NumericTextDinamic';
// export const DropDownCellCapacidades = props => {
  var thisState;
  var optionsCapacidades = [];
  //var DropDownCellTipoVasilha = null;

  // myFunction()
  // function myFunction() {
  //   (async () => {
  //       const data = {}
  //       const TipoVasilha = await services.apiCall.requestApi(
  //           "/Fiscalizacao/GetCapacidades",
  //           data,
  //           "get"
  //       );
        
  //       TipoVasilha.map((tipo) => (
  //         optionsCapacidades.push({text: tipo.capacidade, value: tipo.idCapacidade})
  //       ));
  // })();};

class DropDownCellCapacidades extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      selectedValue: null,
      datatav: null
    };
  }

  componentDidMount() {
    thisState = this;
    (async () => {
      const data = {}
      const TipoVasilha = await services.apiCall.requestApi(
          "/Fiscalizacao/GetCapacidades",
          data,
          "get"
      );
      
      TipoVasilha.map((tipo) => (
        optionsCapacidades.push({text: tipo.cl + ' cl', value: tipo.idcapacidade})
      ));

      this.setState({ datatav: 1 }); 
    })();
  }

  static changebyCorrelativa(value , dataItem){
    console.log(value)
    const matchedOption = optionsCapacidades.find(option => option.text === value.split(" - ")[3]);
    if (matchedOption) {
      console.log(thisState.props)
      dataItem["CapacidadeND"] = matchedOption;
      thisState.setState({ selectedValue: matchedOption.value });
      thisState.forceChange(matchedOption);
    }
  }

  forceChange = (value) => {
    const syntheticEvent = { target: { value } };
    this.handleChange(syntheticEvent);  // Chama handleChange com um evento simulado
  }

  handleChange = e => {
    this.props.onChange({
      dataIndex: 0,
      dataItem: this.props.dataItem,
      field: this.props.field,
      syntheticEvent: e.syntheticEvent,
      value: e.target.value
    });
    this.setState({ selectedValue: e.target.value });
  }

  render() {

    const {
      dataItem
    } = this.props;
    const field = this.props.field || '';
    var indexId = dataItem.ProductID;
    if(dataItem.inEdit == true){
      indexId = 0
    }
    const dataValue = dataItem[field] === null ? '' : dataItem[field];

    if(dataItem.idCapacidadeEng != undefined && dataItem.idCapacidadeEng != null && optionsCapacidades.length> 0){
      var dataEnter = optionsCapacidades.find(c => c.value === (dataItem.idCapacidadeEng))
    }

    if(field == "CapacidadeND" && $("#id-label-verified-solicited").is(":checked") == false){
      var dataValue2 = dataItem["CapacidadeNDNovo"] != undefined ? dataItem["CapacidadeNDNovo"] : dataItem[field] == undefined ? dataItem["capacidadeAE"] === null ? '' : dataItem["capacidadeAE"] : dataItem[field];
      if(dataItem.Correlativa != "" && dataItem.Correlativa != undefined && dataItem.Correlativa != null){
        return <td>
        {(dataValue2 != null ?  dataValue2.toString() : undefined)}
          </td>
      }
      else{
        if(document.getElementsByClassName("NGarrafasND")[indexId] != undefined && dataValue2 != undefined && dataValue2 != ""){
          var numerogarrafas = document.getElementsByClassName("NGarrafasND")[indexId].value;
          var capacidadeQNTFinal = dataValue2.text != undefined ? dataValue2.text.toString() : dataValue2;
          
          if(capacidadeQNTFinal != '' && capacidadeQNTFinal != undefined && numerogarrafas != "" && numerogarrafas != undefined){
            var contaQtdFinal = parseFloat(parseInt(numerogarrafas) * parseFloat(parseInt(capacidadeQNTFinal) / 100));
            document.getElementsByClassName("TotalQBDND")[indexId].value = String(contaQtdFinal);
            document.getElementsByClassName("TotalQBDND")[indexId].text = String(contaQtdFinal);
            dataItem.TotalQBD = String(contaQtdFinal);
          }
        }
        // if(field == "CapacidadeFDO"){
        //   var dataValue2 = dataItem[field] == undefined ? dataItem["CapacidadeFDO"] === null ? '' : dataItem["CapacidadeFDO"] : dataItem[field];
        // if(dataItem.Correlativa != "" && dataItem.Correlativa != undefined && dataItem.Correlativa != null){
        //   return <td>
        //   {(dataValue2 != null ?  dataValue2.toString() : undefined)}
        //     </td>
        // }  
        return (
          <td>
              {dataItem.inEdit ?
              <DropDownList
                popupSettings={{
                  width: 'max-content',
                }}
                onChange={this.handleChange}
                value={optionsCapacidades.find(c => c.value === (dataValue2 != null ? dataValue2.value != null ? dataValue2.value :dataValue2 : null))}
                data={optionsCapacidades}
                textField="text"
                id='id-DropDownCellCapacidades'
              />
              : dataValue2 != null && dataValue2 != "" ? dataValue2.text != undefined ?  dataValue2.text.toString() : dataValue2 : undefined}
          </td>
      );
      }
    }

    return (
      <td>
        {dataItem.inEdit ? (
          <DropDownList
            popupSettings={{
              width: 'max-content',
            }}
            onChange={this.handleChange}
            value={optionsCapacidades.find(c => c.value === this.state.selectedValue) || dataValue}
            data={optionsCapacidades}
            textField="text"
            id='id-DropDownCellCapacidades'
          />
        ) : (


          dataValue != null && dataValue !== "" && dataValue !== undefined  ? dataValue.text.toString() : dataEnter != null ? dataEnter.text  : undefined
        )}
      </td>
    );
  }
    
}

export default DropDownCellCapacidades;